import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const errorMessages = {
  404: "Oops! The page you are looking for does not exist.",
  500: "Internal Server Error. Something went wrong!",
  403: "You do not have permission to access this page.",
  401: "Unauthorized. Please log in to continue.",
  400: "Bad Request. Please check your request and try again.",
  default: "An unexpected error occurred. Please try again later.",
};

const ErrorPage = ({ statusCode = 404 }) => {
  const navigate = useNavigate();
  const errorMessage = errorMessages[statusCode] || errorMessages.default;

  return (
    <Box
      minH="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      bg="gray.100"
    >
      <VStack
        spacing={6}
        p={8}
        bg="white"
        boxShadow="lg"
        borderRadius="lg"
        w="90%"
        maxW="500px"
      >
        <Heading color="red.500" fontSize="6xl">
          {statusCode}
        </Heading>
        <Text fontSize="lg">{errorMessage}</Text>
        <Button colorScheme="blue" onClick={() => navigate("/")}>
          Go Back Home
        </Button>
      </VStack>
    </Box>
  );
};

export default ErrorPage;